// import { logger } from '@/utils';
import { autobind, Injectable } from '@kaokei/use-vue-service';
// import { DaoService } from '../dao.service';
import { useRoute, useRouter } from 'vue-router';

const StepArr = () => [
  {
    label: '分享窗口',
    status: 'process',
    resultStatus: 'wait',
    recordError: false,
    comName: 'step-one',
    stepType: 0,
  },
  {
    label: '设备开启',
    status: 'wait',
    resultStatus: 'wait',
    recordError: false,
    comName: 'step-two',
    stepType: 1,
  },
];
@Injectable()
export class RecordVideoService {
  route: any = useRoute();
  router: any = useRouter();

  // 检测步骤
  public checkStep = StepArr();
  // 检测索引
  public currentStepIndex = 0;
  public currentItemCom = '';
  public videoUploadVisible = false;
  public guideMaskVisible = true;
  public checkRecordSuccess = false;
  // 是否展示答题区域
  public showAnswerArea = true;
  public isRecording = false;

  public mockDev() {
    this.currentItemCom = 'record-module';
    this.toggleGuideMask(true);
  }

  // constructor() {}
  public get showDeviceCheck() {
    return this.currentItemCom === 'device-check';
  }

  public get showRecordModule() {
    return this.currentItemCom === 'record-module';
  }

  public get showRecordScreenCom() {
    const { suffix } = this.route.params;
    return suffix === 'recorder';
  }

  // 是否一进页面就展示检查
  public get isVisibleCheck() {
    const { withCheck } = this.route.query;
    return Boolean(withCheck);
  }

  // 是否是录制页面
  public get isRecorderPage() {
    const { suffix } = this.route.params;
    return suffix === 'recorder';
  }

  @autobind
  public setCheckSuccess(flag: boolean) {
    this.checkRecordSuccess = flag;
  }

  @autobind
  public init() {
    this.checkRecordSuccess = false;
    if (this.isVisibleCheck) {
      this.currentItemCom = 'device-check';
      this.showAnswerArea = false;
    }
  }

  @autobind
  public reGetRecordLogic() {
    this.checkStep = StepArr();
    this.currentStepIndex = 0;
    this.setShowAnswerArea(false);
    this.goRecordGuide();
  }

  public setShowAnswerArea(flag: boolean) {
    this.showAnswerArea = flag;
  }

  @autobind
  public toggleGuideMask(initFlag: boolean | undefined) {
    this.guideMaskVisible =
      initFlag !== undefined ? initFlag : !this.guideMaskVisible;
  }

  @autobind
  public goRecordModule() {
    this.currentItemCom = 'record-module';
  }

  @autobind
  public goRecordGuide() {
    this.currentItemCom = 'device-check';
  }

  @autobind
  public hideRecordCom() {
    this.currentItemCom = '';
  }

  @autobind
  public showVideoUpload() {
    this.videoUploadVisible = true;
    this.setShowAnswerArea(true);
  }

  @autobind
  public goStep(index: number) {
    this.currentStepIndex = index;
    for (let i = 0; i < this.checkStep.length; i++) {
      const itemStep = this.checkStep[i];
      if (i < index) {
        const { resultStatus, status } = itemStep;
        this.checkStep[i] = {
          ...itemStep,
          status: ['error'].includes(status)
            ? 'error'
            : ['error'].includes(resultStatus)
            ? 'error'
            : 'finish',
        };
      } else if (i === index) {
        this.checkStep[i] = {
          ...itemStep,
          status: 'process',
        };
      } else {
        this.checkStep[i] = {
          ...itemStep,
          status: 'wait',
        };
      }
    }
  }
}
